<template>
  <div class="container">
    <sr-header />
    <section class="content">
      <router-view />
    </section>
  </div>
</template>

<script>
import SrHeader from "./sr-header"

export default {
  name: "HomeAuth",
  components: {
    SrHeader
  },
}
</script>
<style scoped lang="scss">
  .container {
    width: 100%;
    min-width: 1200px;
    min-height: 100vh;
  }

  .content {
    min-height: calc(100vh - 90px);
    display: flex;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    max-width: 1260px;
    /*justify-content: center;*/
  }
</style>
